import React from 'react';
import { Button, Table, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import ThreeColumnTableRow from '../CreateCourse/ThreeColumnTableRow';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class AddedSemesterInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            optionalCoursesECTSMin: this.props.sPsemester.optionalCoursesECTSMin,
            optionalCoursesECTSMax: this.props.sPsemester.optionalCoursesECTSMax,
            optionalCoursesNumberMin: this.props.sPsemester.optionalCoursesNumberMin,
            optionalCoursesNumberMax: this.props.sPsemester.optionalCoursesNumberMax,
            edit: false
        };
        this.onChange = this.onChange.bind(this);
        this.saveSemesterInfo = this.saveSemesterInfo.bind(this);
    }

    onChange(keyName, value) {
        this.setState({ [keyName]: value });
    }

    saveSemesterInfo(
        optionalCoursesECTSMin,
        optionalCoursesECTSMax,
        optionalCoursesNumberMin,
        optionalCoursesNumberMax
    ) {
        const { sPsemester } = this.props;
        let studyProgramSemesterId = sPsemester.studyProgramSemester.id;
        let optlock = sPsemester.optLock;
        let id = sPsemester.id;

        let semesterObj = {
            optionalCoursesECTSMin,
            optionalCoursesECTSMax,
            optionalCoursesNumberMin,
            optionalCoursesNumberMax,
            studyProgramSemesterId,
            optlock,
            id
        };
        if (!optionalCoursesECTSMin || !optionalCoursesECTSMax || !optionalCoursesNumberMin || !optionalCoursesNumberMax || !studyProgramSemesterId) {
            toast('Niste unijeli sva obavezna polja!');
            if (!optionalCoursesECTSMin) { this.setState({ optionalCoursesECTSMinErr: true }); } else { this.setState({ optionalCoursesECTSMinErr: false }); }
            if (!optionalCoursesECTSMax) { this.setState({ optionalCoursesECTSMaxErr: true }); } else { this.setState({ optionalCoursesECTSMaxErr: false }); }
            if (!optionalCoursesNumberMin) { this.setState({ optionalCoursesNumberMinErr: true }); } else { this.setState({ optionalCoursesNumberMinErr: false }); }
            if (!optionalCoursesNumberMax) { this.setState({ optionalCoursesNumberMaxErr: true }); } else { this.setState({ optionalCoursesNumberMaxErr: false }); }
            if (!studyProgramSemesterId) { this.setState({ semesterErr: true }); } else { this.setState({ semesterErr: false }); }
        } else if (parseInt(optionalCoursesECTSMin,10) < 0 || parseInt(optionalCoursesECTSMax,10) < 0 || parseInt(optionalCoursesNumberMin,10) < 0 || parseInt(optionalCoursesNumberMax,10) < 0) {
            toast('Vrijednosti moraju biti pozitivne!');
            this.setState({
                optionalCoursesECTSMinErr: true,
                optionalCoursesECTSMaxErr: true,
                optionalCoursesNumberMinErr: true,
                optionalCoursesNumberMaxErr: true
            });
        } else if ( parseInt(optionalCoursesECTSMin,10) > parseInt(optionalCoursesECTSMax,10)) {
            toast('Maksimalna vrijednost mora biti veća od minimalne vrijendosti!');
            this.setState({
                optionalCoursesECTSMinErr: true,
                optionalCoursesECTSMaxErr: true
            });
        } else if (parseInt(optionalCoursesNumberMin,10) > parseInt(optionalCoursesNumberMax,10)) {
            toast('Maksimalna vrijednost mora biti veća od minimalne vrijendosti!');
            this.setState({
                optionalCoursesNumberMinErr: true,
                optionalCoursesNumberMaxErr: true
            });
        } else {
            axios.put('study-programs/semesters/', { ...semesterObj })
                .then(res => {
                    this.props.saveSemesterInfo();
                })
                .catch(err => {
                    toast('Došlo je do greške! Dodavanje informacija o semestru nije uspjelo.');
                });
        }
    }

    render() {
        const { sPsemester } = this.props;
        return (
            <Segment clearing>
                <Table celled unstackable compact>
                    <Table.Header>
                        <Table.Row>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        <ThreeColumnTableRow
                            name="  broj ECTS bodova za izborne predmete"
                            keyName="optionalCoursesECTSMin"
                            value={sPsemester.optionalCoursesECTSMin}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={sPsemester.optionalCoursesECTSMin}
                        />
                        <ThreeColumnTableRow
                            name="Maksimalan broj ECTS bodova za izborne predmete"
                            keyName="optionalCoursesECTSMax"
                            value={sPsemester.optionalCoursesECTSMax}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={sPsemester.optionalCoursesECTSMax}
                        />
                        <ThreeColumnTableRow
                            name="Minimalan broj izbornih predmeta"
                            keyName="optionalCoursesNumberMin"
                            value={sPsemester.optionalCoursesNumberMin}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={sPsemester.optionalCoursesNumberMin}
                        />
                        <ThreeColumnTableRow
                            name="Maksimalan broj izbornih predmeta"
                            keyName="optionalCoursesNumberMax"
                            value={sPsemester.optionalCoursesNumberMax}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={sPsemester.optionalCoursesNumberMax}
                        />
                    </Table.Body>
                </Table>
                {!this.state.edit ?
                    <Button floated="right" primary onClick={() => this.setState({ edit: true })}>Izmijeni</Button>
                    : <div><Button floated="right" basic="true" color="blue" onClick={() => this.setState({ edit: false })}>Odustani</Button>
                        <Button
                            floated="right"
                            primary
                            onClick={() => this.saveSemesterInfo(
                                this.state.optionalCoursesECTSMin,
                                this.state.optionalCoursesECTSMax,
                                this.state.optionalCoursesNumberMin,
                                this.state.optionalCoursesNumberMax
                            )}
                        >
                          Sačuvaj izmjene</Button>
                    </div>}

                <ToastContainer hideProgressBar />
            </Segment>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgramImplementation/AddedSemesterInfo.js